export default {
  title: "Products or services",
  titleDescription: "Enter the total amount of all medicines units",
  cosharings: "Participaciones",
  beneficiaryPayment: "Beneficiary",
  sponsorPayment: "Sponsor",
  invoiceData: "Invoice information for sponsor (Optional)",
  enterData: "Enter the following information",
  copaymentDescription: "*Copayment",
  coinsuranceDescription: "*Coinsurance",
  invoice: {
    labels: {
      upload: "Invoice (Optional)",
      uploadRestrictions: "Files in PDF, PNG or JPEG format, maximum size 20Mb",
      number: "Invoice number",
      amount: "Amount invoiced",
      date: "Invoice date",
      noFiles: "No files attached"
    }
  },
  buttons: {
    cosharings: {
      get: "Get shares",
      update: "Update participations"
    },
    uploadFile: "Add"
  },
  errors: {
    multipleFileUpload: "Only one file can be uploaded at a time"
  },
  headers: {
    quantity: "Count",
    productName: "Name",
    status: "Status",
    subtotal: "Unit price"
  },
  status:{
    approved: "Approved",
    rejected: "Rejected"
  },
  validations: {
    cosharings: "You must get the co-sharings to continue.",
    invoiceFields: "Enter invoice information for sponsor.",
    invoiceFile: "You must add the invoice file"
  }
}